/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Message from './Message';

/**
 * The MessageType model module.
 * @module model/MessageType
 * @version 1.0.0
 */
class MessageType {
    /**
     * Constructs a new <code>MessageType</code>.
     * Message type with related message
     * @alias module:model/MessageType
     * @param id {Number} 
     * @param name {String} 
     */
    constructor(id, name) { 
        
        MessageType.initialize(this, id, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name) { 
        obj['id'] = id;
        obj['name'] = name;
    }

    /**
     * Constructs a <code>MessageType</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MessageType} obj Optional instance to populate.
     * @return {module:model/MessageType} The populated <code>MessageType</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MessageType();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('related_messages')) {
                obj['related_messages'] = ApiClient.convertToType(data['related_messages'], [Message]);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
MessageType.prototype['id'] = undefined;

/**
 * @member {String} name
 */
MessageType.prototype['name'] = undefined;

/**
 * @member {Array.<module:model/Message>} related_messages
 */
MessageType.prototype['related_messages'] = undefined;






export default MessageType;

